import Rand from "../../util/Rand";
import Value from "./Value";
import { ValueType } from "./ValueType";

export default class NumberValue extends Value {
    /**
     * @param {string} id 
     * @param {number} initialValue
     */
    constructor(id, initialValue) {
        super(id);

        /**
         * @type {number}
         */
        this.value = initialValue;
        /**
         * @constant
         * @type {number}
         */
        this.initialValue = initialValue;
    }

    /**
     * @returns {number}
     */
    getValue() {
        return this.value;
    }

    /**
     * @param {number} value 
     */
    setValue(value) {
        this.value = value;
    }

    /**
     * @param {number} value 
     */
    incrementValue(value) {
        this.value += value;
    }

    /**
     * @param {number} value 
     */
    decrementValue(value) {
        this.value -= value;
        if (this.value < this.initialValue) {
            this.value = this.initialValue;
        }
    }

    /**
     * This is only applicable if the value represents a percent.
     * @returns {boolean} True if the percentage is randomly determined to be applied.
     */
    isPercentageApplied() {
        if (this.value <= 0) {
            return false;
        }
        else if (this.value >= 100) {
            return true;
        }
        return Rand.randomInt(100) < this.value;
    }

    /**
     * If the value represents a percentage, return it as a fraction.
     * @returns {number}
     */
    getPercentAsFraction() {
        return this.value === 0 ? 0 : this.value / 100.0
    }

 
    /**
     * @override
     */
    reset() {
        this.value = this.initialValue;
    }

    /**
     * @override
     * @returns {number}
     */
    getValueType() {
        return ValueType.NUMBER;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isAtInitialValue() {
        return this.value === this.initialValue;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isValueApplicable() {
        return this.value > 0;
    }
    
}